/**
 * Undo helper for status changes.
 *
 * Shows a Sonner toast with a "Rückgängig" button that calls the undo handler.
 * Typical flow:
 *
 *   undoableAction({
 *     label: 'Status: Bestätigt',
 *     undoLabel: 'Rückgängig',
 *     onUndo: async () => api.post(`/reservations/${id}/status`, { status: prevStatus }),
 *     onUndone: load,            // refresh UI after undo
 *     duration: 7000,            // ms — give the waiter time to react
 *   });
 */

import { toast } from 'sonner';

export function undoableAction({
  label,
  description = '',
  undoLabel = 'Rückgängig',
  onUndo,
  onUndone,
  duration = 7000,
}) {
  toast.success(label, {
    description,
    duration,
    action: {
      label: undoLabel,
      onClick: async () => {
        try {
          await onUndo();
          toast.success('Rückgängig gemacht');
          if (onUndone) onUndone();
        } catch (e) {
          const msg = e?.response?.data?.detail || 'Konnte nicht rückgängig gemacht werden';
          toast.error(msg);
        }
      },
    },
  });
}
